var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndDayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0b3c88;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,39.5H9c-4.7,0-8.5-3.8-8.5-8.5V9C.5,4.3,4.3.5,9,.5h23c4.7,0,8.5,3.8,8.5,8.5v22c0,4.7-3.8,8.5-8.5,8.5ZM9,3.5c-3,0-5.5,2.5-5.5,5.5v22c0,3,2.5,5.5,5.5,5.5h23c3,0,5.5-2.5,5.5-5.5V9c0-3-2.5-5.5-5.5-5.5H9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,27.8c-.4,0-.9-.2-1.2-.5l-4.9-4.8c-.7-.7-.7-1.8,0-2.5.7-.7,1.8-.7,2.5,0l3.6,3.6,10.9-10.8c.7-.7,1.8-.7,2.5,0,.7.7.7,1.8,0,2.5l-12.1,12c-.3.3-.8.5-1.2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndDayIcon);
export default __webpack_public_path__ + "static/media/End Day Icon.cc2d33100c570e37b71f99da9ae0c0a8.svg";
export { ForwardRef as ReactComponent };